import React from 'react';

import FileWhatsapp from 'components/Tvendo/Reports/File/list.js';

export default function () {
  return <FileWhatsapp />;
}
